export const setAuthTokenCookie = (token) => {
  const d = new Date();
  // Set cookie to expire in 30 days
  d.setTime(d.getTime() + (30 * 24 * 60 * 60 * 1000));
  let expires = "expires=" + d.toUTCString();
  document.cookie = `authToken=${token};${expires};path=/;SameSite=Strict`;
};

export const getAuthTokenCookie = () => {
  const name = "authToken=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const removeAuthTokenCookie = () => {
  document.cookie = "authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;SameSite=Strict";
};
